// extracted by mini-css-extract-plugin
export default {"footerBg":"a-z","footerTopLinks":"b-z","footerFeedback":"c-z","footerSocial":"d-z","footerLegalLinks":"e-z","footerIconCards":"f-z","footerBotCopy":"g-z"};